/*global FakeCation*/
(function (FC) {
"use strict";

  FC.utils.registerFilter('colorAvgFromFirstRow', function (imgData, cb) {
    var i, diff, data = imgData.data, refColor, color;
    var width = imgData.width,
        cols = 0,
        refColors = [];

    // get color average from first row of the picture
    for(cols; cols < width*4; cols += 4){
      refColors.push(new FC.colorUtils.Color(data[cols], data[cols+1], data[cols+2]));
    }
    console.log(refColors);
    console.log(FC.colorUtils.Color.average(refColors));

    // refColor = FC.colorUtils.getColor(imgData, 100, 100);
    refColor = FC.colorUtils.Color.average(refColors);
    console.log(imgData);
    console.log(refColor);

    for (i = 0; i < data.length; i += 4) {
      color = new FC.colorUtils.Color(data[i], data[i+1], data[i+2]);
      diff = refColor.diffHsl(color);

      data[i+3] = diff < 2 ? 0 : 255;
    }

    cb(imgData);
  });
}(FakeCation));
